<template>
  <div id="apppp">
    <!-- 头部开始 -->
    <div class="div1" v-if="timeOut === false">
      <div class="tiops">
        <i
          class="el-icon-arrow-left"
          @click="yxOutHandle"
          style="color: #000000; font-size: 18px; cursor: pointer"
          >{{ gameName }}</i
        >
      </div>
      <div class="tiops">
        {{ prompt }}
      </div>
      <div class="tiops" style="margin-right: 50px">
        <div v-if="countdown !== null">
          <i
            class="el-icon-alarm-clock"
            style="color: yellowgreen; font-size: 20px; cursor: pointer"
          ></i>
          <span
            style="font-size: 24px; margin-left: 10px; color: yellowgreen"
            >{{ countdown }}</span
          >
        </div>
      </div>
    </div>
    <!-- 头部结束 -->
    <!-- 内容区 -->
    <div class="div2">
      <!-- 背景图和音乐开始 -->
      <MusicPopup
        ref="myButton"
        class="bag"
        v-if="timeOut === true"
        :type="courseType"
        @event="handleEvent"
      ></MusicPopup>
      <!-- 背景图和音乐结束 -->
      <hengzhiyundong
        ref="child"
        v-if="timeOut === false && gameName == '横向捕捉' && yxStart"
        v-bind:dataTypes="dataTypes"
        :seconds="questionData.seconds"
        @answerEvent="answerEvent"
      ></hengzhiyundong>
      <zongxiang
        v-if="timeOut === false && gameName == '纵向捕捉' && yxStart"
        v-bind:dataTypes="dataTypes"
        :seconds="questionData.seconds"
        @answerEvent="answerEvent"
      ></zongxiang>
      <duijiaoxian
        ref="child"
        v-if="timeOut === false && gameName == '对角捕捉' && yxStart"
        v-bind:dataTypes="dataTypes"
        :seconds="questionData.seconds"
        @answerEvent="answerEvent"
      ></duijiaoxian>
      <baziwu
        v-if="timeOut === false && gameName == '8字捕捉' && yxStart"
        v-bind:dataTypes="dataTypes"
        :seconds="questionData.seconds"
        @answerEvent="answerEvent"
      ></baziwu>
      <zimukuaishan
        v-if="
          timeOut === false &&
          yxStart &&
          (gameName == '字母快闪' ||
            gameName == '字符快闪' ||
            gameName == '数字快闪' ||
            gameName == '词句快闪')
        "
        :aaasss="aaasss"
        :xuanzhong="xuanzhong"
        :seconds="questionData.seconds"
        v-bind:dataTypes="questionData"
        @answerEvent="answerEvent"
        @abcde="abcde"
      ></zimukuaishan>
      <ImageFlash
        v-if="timeOut === false && gameName == '图片快闪' && yxStart"
        :aaasss="aaasss"
        :xuanzhong="xuanzhong"
        :seconds="questionData.seconds"
        v-bind:dataTypes="questionData"
        @answerEvent="choiceQuestion"
        @abcde="abcde"
      ></ImageFlash>
      <Otherwise
        v-if="timeOut === false && gameName == '非此即彼' && yxStart"
        v-bind:dataTypes="questionData"
        @answerEvent="choiceQuestion"
        :xuanzhong="xuanzhong"
        @abcde="abcde"
      ></Otherwise>
      <yilanwuyu
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="answerEvent"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '一览无余' && yxStart"
      ></yilanwuyu>
      <jiyiyouxin
        v-bind:dataTypes="questionData"
        @answerEvent="answerEvent"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '记忆犹新' && yxStart"
      ></jiyiyouxin>
      <mingbianshifei
        v-bind:dataTypes="questionData"
        :xuanzhong="xuanzhong"
        @answerEvent="choiceQuestion"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '明辨是非' && yxStart"
      ></mingbianshifei>
      <shuzishuerte
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="choiceQuestion"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '数字舒尔特' && yxStart"
      ></shuzishuerte>
      <huiyanshizhu
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="answerEvent"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '慧眼识珠' && yxStart"
      ></huiyanshizhu>
      <wanlitiaoyi
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="choiceQuestion"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '万里挑一' && yxStart"
      ></wanlitiaoyi>
      <mihuanzongji
        ref="child"
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="answerEvent"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '迷幻踪迹' && yxStart"
      ></mihuanzongji>
      <cengcengdijin
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="autoContinue"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '层层递进' && yxStart"
      ></cengcengdijin>
      <wuduyouou
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="choiceQuestion"
        @obsver="obsver"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '无独有偶' && yxStart"
      ></wuduyouou>
      <duihaoruzuo
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="choiceQuestion"
        @obsver="obsver"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '对号入座' && yxStart"
      ></duihaoruzuo>
      <tupianlianliankan
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        :flag="flag"
        @answerEvent="choiceQuestion"
        @obsver="obsver"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '图片连连看' && yxStart"
      ></tupianlianliankan>
      <shengyinlianlianpan
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        :flag="flag"
        @answerEvent="choiceQuestion"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '声音连连判' && yxStart"
      ></shengyinlianlianpan>
      <kuaisubohao
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        :flag="flag"
        @answerEvent="choiceQuestion"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '快速拨号' && yxStart"
      ></kuaisubohao>
      <sekuaipaixu
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="choiceQuestion"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '色块排序' && yxStart"
      ></sekuaipaixu>
      <yiqingerchu
        v-bind:dataTypes="questionData"
        :seconds="questionData.seconds"
        @answerEvent="choiceQuestion"
        @obsver="obsver"
        @abcde="abcde"
        v-if="timeOut === false && gameName == '一清二楚' && yxStart"
      ></yiqingerchu>
      <!-- <yuedu v-if="timeOut === false && gameName=='阅读'" v-bind:dataTypes="cRtData"  ></yuedu> -->
      <div
        v-if="active_index === 2"
        class="passaGes"
        :class="{ scroll: readingIndex == 4 && isNormal }"
      >
        <template v-if="multipleQuestion == true && !ArticlePopup">
          <!-- 第一篇 直读法 -->
          <template v-if="readingIndex == 0">
            <template v-for="(arr, Index) in bookArr">
              <div v-if="Index === Num" :key="Index" class="flex-box">
                <div
                  class="row"
                  :class="{ active: index == num }"
                  v-for="(item, index) in arr"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </template>
          </template>
          <!-- 第二篇 闪烁跟读 -->
          <div v-if="readingIndex == 1" :class="{ flicker: readingIndex == 1 }">
            <template v-for="(item, index) in bookArr">
              <div class="flicker-box" :key="index" v-if="index === row">
                {{ item }}
              </div>
            </template>
          </div>
          <!-- 第三篇 指移跟读 -->
          <template v-if="readingIndex == 2">
            <div
              class="{'active':add_class==true }"
              v-for="(item, index) in bookArr"
              :key="index"
            >
              <div v-if="index === row" :class="`position-${index % 4}`">
                {{ item }}
              </div>
            </div>
          </template>
          <!-- 第四篇 线式阅读A -->
          <template v-if="readingIndex == 3">
            <template v-for="(arr, Index) in bookArr">
              <div v-if="Index === Num" :key="Index" class="flex-box">
                <div
                  class="row"
                  :class="{ active: index == num }"
                  v-for="(item, index) in arr"
                  :key="index"
                >
                  <span class="hide" :class="{ active: numA == 0 }">{{
                    item.slice(0, item.length / 2)
                  }}</span>
                  <span class="hide" :class="{ active: numA == 1 }">{{
                    item.slice(-item.length / 2 - 1)
                  }}</span>
                </div>
              </div>
            </template>
          </template>
          <!-- 第五篇 线式阅读B -->
          <template v-if="readingIndex == 4 && !isNormal">
            <template v-for="(arr, Index) in bookArr">
              <div
                v-if="Index === Num"
                :key="Index"
                class="flex-box lineB-color"
              >
                <div
                  style="text-align: center"
                  v-for="(item, index) in arr"
                  :key="index"
                >
                  <span :class="{ 'fs-bold': index == num && numA == 0 }">{{
                    item.slice(0, LinearReadingB[0])
                  }}</span>
                  <span :class="{ 'fs-bold': index == num }">{{
                    item.slice(
                      LinearReadingB[0],
                      LinearReadingB[0] + LinearReadingB[1]
                    )
                  }}</span>
                  <span :class="{ 'fs-bold': index == num && numA == 1 }">{{
                    item.slice(-LinearReadingB[2])
                  }}</span>
                </div>
              </div>
            </template>
          </template>
          <!-- 第五篇 普通阅读 -->
          <div v-if="readingIndex == 4 && isNormal">
            <div
              class="indent"
              v-for="(items, index) in cRtData.course[0].content"
              :key="index"
            >
              {{ items }}
            </div>
          </div>
        </template>
        <!-- 选择题 -->
        <template v-if="multipleQuestion == false">
          <el-row class="rowTitle" :gutter="10">
            <el-col :span="12">
              <div>
                答题进度 <span style="font-size: 3.4vh">{{ redIndex + 1 }}</span
                >/{{ cRtData.course[0].children.length }}
              </div>
            </el-col>
            <el-col :span="12">
              <div
                style="text-align: right; padding-right: 50px; color: #3685fa"
              >
                剩余时间：{{ countdown1 }}S
              </div>
            </el-col>
          </el-row>
          <el-progress
            :text-inside="false"
            :percentage="percentage"
            :color="customColor"
            :format="format"
          ></el-progress>

          <div class="questions" :class="{ disabled: isClick == true }">
            <div>{{ redIndex + 1 }}.{{ radData.title }}</div>
            <div style="font-size: 2.4vh" v-if="nextLevel == 1">
              答案：{{ radData.answer }}
            </div>
            <el-radio-group v-model="radios" @change="agreeChange">
              <el-form label-width="80px">
                <el-form-item
                  label=""
                  v-for="(is, inout) in radData.option"
                  :key="`${redIndex}${inout}`"
                  style="margin: 8px 0; font-size: 18px"
                >
                  <el-radio :label="is"></el-radio>
                </el-form-item>
              </el-form>
            </el-radio-group>
            <img
              class="centerImg"
              src="../../../assets/1-dui.png"
              v-if="xuanzhong == 1"
            />
            <img
              class="centerImg"
              src="../../../assets/1-cuo.png"
              v-if="xuanzhong == 2"
            />
          </div>
        </template>
      </div>
    </div>
    <!-- 页面底部开始 -->
    <div class="div3" v-if="timeOut === false">
      <el-row>
        <el-col :span="10">
          <div v-if="active_index == 1" class="grid-content bg-purple">
            <div
              :class="progressIndex === nnns ? 'yuanActiv' : 'yuandian'"
              v-for="(item, nnns) in chapters"
              :key="nnns"
              @click="yxStep(nnns)"
            ></div>
          </div>
          <div
            v-if="active_index == 2 && readingIndex != 4"
            class="articleTitle"
          >
            {{ methodList[readingIndex] }}
          </div>
          <div
            v-if="active_index == 2 && readingIndex == 4"
            class="articleTitle"
          >
            {{ isNormal ? "阅读测评" : "面式阅读" }}
          </div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple-light">
            <div class="dot">
              <button
                v-show="
                  readingIndex == 4 &&
                  !ArticlePopup &&
                  multipleQuestion &&
                  isNormal &&
                  showBtn
                "
                class="tton ttonse"
                @click="ReadItWell"
              >
                读好了
              </button>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple right">
            <el-steps
              :active="active_index"
              finish-status="success"
              :space="80"
            >
              <el-step
                v-for="(poic, index) in stepParams"
                :key="index"
                @click.native="handleStep(index)"
              ></el-step>
            </el-steps>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 页面底部结束 -->
    <!-- 引入弹窗组件开始 -->
    <StartPopup
      :textmsg="textmsg"
      :centerDialogVisible="centerDialogVisible"
      @event="clickEvent"
    ></StartPopup>
    <AnswerPopup
      v-if="answerPopup"
      :radioLisr="questionData"
      :xuanzhong="xuanzhong"
      :textmsg="textmsg"
      :answerPopup="answerPopup"
      @choiceQuestion="choiceQuestion"
    ></AnswerPopup>
    <FailedPopUp :FailPopup="FailPopup"> </FailedPopUp>
    <ReadingPopup
      v-if="cRtData.course"
      :dataTypes="cRtData"
      :ArticlePopup="ArticlePopup"
      @choiceQuestion="cdeClick"
    ></ReadingPopup>
    <YxOutPopUp
      v-if="isBack"
      @confirm="exitReturn"
      @cancle="cancleBack"
    ></YxOutPopUp>
    <!-- 引入弹窗组件结束 -->
    <!-- 音乐 -->
    <audio controls ref="answerYes" class="aud">
      <source src="../../../componentsGame/audio/answerYes.mp3" />
    </audio>
    <audio controls ref="answerNo" class="aud">
      <source src="../../../componentsGame/audio/answerNo.mp3" />
    </audio>
    <audio controls ref="music" class="aud">
      <source src="../../../componentsGame/audio/22.mp3" />
    </audio>
  </div>
</template>
<script>
import MusicPopup from "@/componentPopUp/MusicPopup.vue"; //进入页面弹窗
import StartPopup from "@/componentPopUp/StartPopup.vue"; //游戏开始弹窗
import AnswerPopup from "@/componentPopUp/AnswerPopup.vue"; //答题弹窗
import FailedPopUp from "@/componentPopUp/FailedPopUp.vue"; //未通过弹窗
import ReadingPopup from "@/componentPopUp/ReadingPopup.vue"; //阅读弹窗
import YxOutPopUp from "@/componentPopUp/YxOutPopup.vue"; //游戏中途退出弹窗
import hengzhiyundong from "@/componentsGame/hengzhiyundong.vue"; //横向捕捉
import zongxiang from "@/componentsGame/zongxiang.vue"; //纵向捕捉
import duijiaoxian from "@/componentsGame/duijiaoxian.vue"; //对角捕捉
import baziwu from "@/componentsGame/baziwu.vue"; //8子捕捉
import zimukuaishan from "@/componentsGame/zimukuaishan.vue"; //字母 数字 字符闪视
import ImageFlash from "@/componentsGame/ImageFlash.vue"; //图片快闪
import Otherwise from "@/componentsGame/Otherwise.vue"; //非左即右
import yilanwuyu from "@/componentsGame/yilanwuyu.vue"; //一览无余
import jiyiyouxin from "@/componentsGame/jiyiyouxin.vue"; //记忆犹新
import mingbianshifei from "@/componentsGame/mingbianshifei.vue"; //明辨是非
import shuzishuerte from "@/componentsGame/shuzishuerte.vue"; //数字舒尔特
import huiyanshizhu from "@/componentsGame/huiyanshizhu.vue"; //慧眼识珠
import wanlitiaoyi from "@/componentsGame/wanlitiaoyi.vue"; //万里挑一
import mihuanzongji from "@/componentsGame/mihuanzongji.vue"; //迷幻踪迹
import cengcengdijin from "@/componentsGame/cengcengdijin.vue"; //层层递进
import wuduyouou from "@/componentsGame/wuduyouou.vue"; //无独有偶
import duihaoruzuo from "@/componentsGame/duihaoruzuo.vue"; //对号入座
import tupianlianliankan from "@/componentsGame/tupianlianliankan.vue"; //图片连连看
import shengyinlianlianpan from "@/componentsGame/shengyinlianlianpan.vue"; //声音连连判
import kuaisubohao from "@/componentsGame/kuaisubohao.vue"; //快速拨号
import sekuaipaixu from "@/componentsGame/sekuaipaixu.vue"; //色块排序
import yiqingerchu from "@/componentsGame/yiqingerchu.vue"; //一清二楚
import yuedu from "@/componentsGame/yuedu.vue"; //阅读
import screenfull from "screenfull";
import dayjs from "dayjs";
import experienceRead from "../experienceRead.js"; //体验课程文章
import {
  getGrade,
  getQuerycour,
  getCapture,
  getRection,
  getDiagonal,
  getBdezng,
  getStatement,
  getLetter,
  getCharacter,
  getDigital,
  getImageFlash,
  getColour,
  getQuestions,
  putAverage,
  putHapterscore,
  getNotLeftbutRight,
  getAtGlance,
  getRemember,
  getDiscerning,
  getSchulteGrid,
  getEyesIdentify,
  getTheOne,
  getPsychedelic,
  getProgressive,
  getGoodThings,
  getAccording,
  getKeepLooking,
  getvoiceKeepLooking,
  getFastMemory,
  getCrystalClear,
  logsbmit,
  addBehaviorLog,
  addCourseGame,
  queryCourseGameId,
  queryGameGradeByCourseId,
  addEnterLog,
} from "@/api/course/courseGames";
export default {
  components: {
    MusicPopup,
    StartPopup,
    AnswerPopup,
    FailedPopUp,
    ReadingPopup,
    YxOutPopUp,
    hengzhiyundong,
    zongxiang,
    duijiaoxian,
    ImageFlash,
    baziwu,
    zimukuaishan,
    Otherwise,
    yilanwuyu,
    jiyiyouxin,
    mingbianshifei,
    shuzishuerte,
    huiyanshizhu,
    wanlitiaoyi,
    mihuanzongji,
    cengcengdijin,
    wuduyouou,
    duihaoruzuo,
    tupianlianliankan,
    shengyinlianlianpan,
    kuaisubohao,
    sekuaipaixu,
    yiqingerchu,
    yuedu,
  },
  data() {
    return {
      state: this.$route.query.state,
      centerDialogVisible: false,
      answerPopup: false,
      FailPopup: false,
      ArticlePopup: false,
      textmsg: {
        title: "测试",
        content: "",
        contentTwo: "",
        image: "", //
        firstWord: "",
        cancel: "取消",
        confirm: "马上开始",
        state: 2,
      },
      Information: "",
      imgUrl: "",
      typeList: null,
      prompt: "",
      countdown: null, //计秒
      countdown1: null, //计秒
      timeOut: true, //控制显示背景图和头部
      yxStart: false, // 游戏开始
      progressIndex: 0, //底部章节进度下标
      active_index: 0, //123选择跳关
      stepParams: [
        { icon: "el-icon-edit", status: "success" },
        { icon: "el-icon-upload", status: "success" },
        { icon: "el-icon-picture", status: "success" },
      ],
      offClasses: false,
      aaasss: false,
      gameName: "",
      chapters: [], //游戏数据
      questionData: [],
      radioLisr: [],
      arrayIndex: 0, //当前游戏下标
      dataTypes: [],
      xuanzhong: "",
      courseId: "",
      courseName: "", //课程名称
      rightIndex: 0, //
      errorIndex: 0,
      percentage: 0,
      reckonTime: 1,
      readingData: [],
      customColor: "#409eff",
      cRtData: {}, //当前文章
      radData: [], //当前文章题目
      readingIndex: 0, //当前阅读进度
      indexs: 0,
      redIndex: 0,
      total: 0,
      radios: "",
      multipleQuestion: null,
      cunData: [], //每一级的数据统计
      ShowHidden: true,
      //  anyStateus:true,
      bookArr: [],
      num: 0,
      rowNumber: 0, //总行数
      row: 0, //第几行
      Num: 0, //文章页数
      numA: 0,
      rowWords: 6, //单行个数
      rowTime: 1000, //单行显示时间
      starttime: null, //开始时间
      readTimer: null, //文章用时定时器
      timer: null,
      timer1: null, //文章弹框计时器
      timer2: null, //文章答题倒计时
      timer3: null,
      gameId: 0,
      yxNum: 0, //当前游戏进度
      isBack: false,
      courseType: "",
      flag: null,
      reanEnd: false,
      methodList: ["直读法", "闪烁跟读", "止移跟读", "线式阅读"],
      LinearReadingB: [],
      isNormal: false, //第五篇为普通阅读
      alginFlag: false, // 是否为跳关权限开始的
      nextLevel: 0,
      gameGradeIdArr: [],
      isClick: false,
      start: "", //进入开始位置
      courseDetail: {},
      levelStartTime: null, //每关卡开始时间
      showBtn: false, //读好了按钮显示
    };
  },
  created() {
    // 禁止浏览器前进和后退箭头点击
    history.pushState(null, null, document.URL);
    window.addEventListener(
      "popstate",
      function (e) {
        history.pushState(null, null, document.URL);
      },
      false
    );
    // 体验课程
    if (this.$route.query.courseType !== "")
      this.courseType = this.$route.query.courseType;
    this.typeList = JSON.parse(sessionStorage.getItem("courseDetail"));
    this.courseName = this.typeList.courseName;
    this.start = this.courseName + "：" + "音乐";
    this.nextLevel = sessionStorage.getItem("nextLevel");
    if (sessionStorage.getItem("userInfo")) {
      let infor = JSON.parse(sessionStorage.getItem("userInfo"));
      if (infor !== null) {
        this.Information = infor;
        // 再读一次不保存音乐日志
        if (this.$route.query.skip != 1 && this.courseType !== "体验课程") {
          // 音乐开始日志
          this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
          let obj = {
            memberId: this.Information.memberId,
            position: this.start,
            startTime: this.levelStartTime,
            type: 1,
          };
          this.addEveryLog(obj);
        }
      }
    }
    screenfull.toggle();
    if (this.typeList) this.courseType = this.typeList.courseType;
    // 再读一遍 跳关
    if (this.typeList && this.$route.query.skip == 1) {
      this.handleEvent(false);
    }
  },
  mounted() {
    this.starttime = dayjs().format("YYYY-MM-DD HH:mm:ss");
    // 监听网页是否退出全屏
    document.onfullscreenchange = (e) => {
      if (!screenfull.isFullscreen) {
        if (this.$refs["child"]) this.$refs["child"].createBox();
      }
    };
    window.onbeforeunload = (e) => {
      e = e || window.event;
      if (e) {
        e.returnValue = "关闭提示";
      }
      return "关闭提示";
    };
  },
  methods: {
    addEnterLog() {
      let obj = {
        type: 0, //课程
        memberId: this.Information.memberId,
        startTime: this.starttime,
        start: this.start,
      };
      addEnterLog(obj).then((res) => {});
    },
    addEveryLog(obj) {
      // console.log("关卡日志", obj);
      addBehaviorLog(obj).then((res) => {});
    },
    // 进入页面背景图和音乐按钮事件
    handleEvent(event) {
      this.timeOut = event;
      if (this.$route.query.skip != 1 && this.courseType !== "体验课程") {
        // 音乐结束日志
        let obj = {
          memberId: this.Information.memberId,
          startTime: this.levelStartTime,
          endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          type: 1,
        };
        this.addEveryLog(obj);
      }
      if (this.$route.query.courseType == "体验课程") this.queryCourseGame();
      if (this.typeList) this.getTake(1);
    },
    /* 
              拿到传过来的数据
            */
    getTake(num) {
      this.courseId = this.typeList.courseId;
      this.courseName = this.typeList.courseName;
      this.setCourseMsg();
      this.chapters = this.typeList.game;
      let flag = this.chapters.findIndex((item, index) => {
        return item.status === true;
      });
      //游戏已通关 直接进入阅读
      if (flag == -1 && this.alginFlag === false) {
        this.alginFlag = true;
        this.progressIndex = this.chapters.length - 1;
        this.arrayIndex = this.chapters.length - 1;
        this.active_index = 2;
        this.prompt = "";
        this.myScriptCourse(1);
        //游戏未通关
      } else {
        this.active_index = 1;
        if (this.alginFlag === false) {
          this.alginFlag = true;
          this.progressIndex = flag;
          this.arrayIndex = flag;
        }
        this.gameId = this.chapters[this.progressIndex].gameId;
        this.gameName = this.chapters[this.progressIndex].gameName;
        this.start = this.courseName + "：" + this.gameName;
        if (num == 1 && this.courseType !== "体验课程") this.addEnterLog();
        if ((num == 1 || num == 2) && this.courseType !== "体验课程") {
          this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
          this.addEnterLog();
          let obj = {
            memberId: this.Information.memberId,
            position: this.start,
            startTime: this.levelStartTime,
            type: 1,
          };
          this.addEveryLog(obj);
        }
        this.prompt = "";
        let gameIdArr = [];
        this.chapters.forEach((item) => {
          gameIdArr.push(item.gameId);
        });
        let obj = {
          courseId: this.typeList.courseId,
          gameIds: gameIdArr + "",
        };
        queryGameGradeByCourseId(obj).then((res) => {
          this.gameGradeIdArr = res.data;
          if (
            this.gameGradeIdArr[this.arrayIndex] &&
            this.gameGradeIdArr[this.arrayIndex].gameGradeId
          ) {
            let arry = this.gameGradeIdArr[this.arrayIndex].gameGradeId;
            this.heangbuo(arry);
          } else {
            this.alginFlag = true;
            this.progressIndex = this.chapters.length - 1;
            this.arrayIndex = this.chapters.length - 1;
            this.active_index = 2;
            this.prompt = "";
            this.myScriptCourse(1);
          }
        });
      }
    },
    // 查询体验课程游戏
    queryCourseGame() {
      queryCourseGameId().then((res) => {
        // 从没玩过的游戏开始
        this.chapters = res.data;
        this.active_index = 1;
        this.gameName = this.chapters[this.arrayIndex].gameName;
        this.prompt = "";
        this.gameId = this.chapters[this.arrayIndex].gameId;
        let arry = this.chapters[this.arrayIndex].gameGradeId;
        this.heangbuo(arry);
      });
    },
    /* 获取游戏需要的数据*/
    heangbuo(id) {
      this.yxNum++; //游戏进度加一
      let getAxios = "";
      if (this.gameName === "横向捕捉") getAxios = getCapture;
      if (this.gameName === "纵向捕捉") getAxios = getRection;
      if (this.gameName === "对角捕捉") getAxios = getDiagonal;
      if (this.gameName === "8字捕捉") getAxios = getBdezng;
      if (this.gameName === "词句快闪") getAxios = getStatement;
      if (this.gameName === "字母快闪") getAxios = getLetter;
      if (this.gameName === "字符快闪") getAxios = getCharacter;
      if (this.gameName === "数字快闪") getAxios = getDigital;
      if (this.gameName === "色块排序") getAxios = getColour;
      if (this.gameName === "图片快闪") getAxios = getImageFlash;
      if (this.gameName === "非此即彼") getAxios = getNotLeftbutRight;
      if (this.gameName === "一览无余") getAxios = getAtGlance;
      if (this.gameName === "记忆犹新") getAxios = getRemember;
      if (this.gameName === "明辨是非") getAxios = getDiscerning;
      if (this.gameName === "数字舒尔特") getAxios = getSchulteGrid;
      if (this.gameName === "慧眼识珠") getAxios = getEyesIdentify;
      if (this.gameName === "万里挑一") getAxios = getTheOne;
      if (this.gameName === "迷幻踪迹") getAxios = getPsychedelic;
      if (this.gameName === "层层递进") getAxios = getProgressive;
      if (this.gameName === "无独有偶") getAxios = getGoodThings;
      if (this.gameName === "对号入座") getAxios = getAccording;
      if (this.gameName === "图片连连看") getAxios = getKeepLooking;
      if (this.gameName === "声音连连判") getAxios = getvoiceKeepLooking;
      if (this.gameName === "快速拨号") getAxios = getFastMemory;
      if (this.gameName === "一清二楚") getAxios = getCrystalClear;

      getAxios(id).then((res) => {
        let ler = this.$Base64.decode(res.msg);
        let serr = JSON.parse(ler);
        this.questionData = serr;
        this.dataTypes = this.questionData.secondImages;
        if (
          this.gameName === "字母快闪" ||
          this.gameName === "字符快闪" ||
          this.gameName === "数字快闪" ||
          this.gameName === "词句快闪" ||
          this.gameName === "图片快闪" ||
          this.gameName === "非此即彼" ||
          this.gameName === "记忆犹新" ||
          this.gameName === "明辨是非" ||
          this.gameName === "层层递进" ||
          this.gameName === "对号入座" ||
          this.gameName === "数字舒尔特" ||
          this.gameName === "无独有偶" ||
          this.gameName === "万里挑一" ||
          this.gameName === "图片连连看" ||
          this.gameName === "声音连连判" ||
          this.gameName === "快速拨号" ||
          this.gameName === "色块排序" ||
          this.gameName === "一清二楚"
        ) {
          this.aaasss = true;
          this.textmsg = {
            title: this.gameName,
            content: this.questionData.startCue,
            contentTwo: "",
            image: this.questionData.firstImage, //
            cancel: "取消",
            confirm: "马上开始",
            state: 2,
            yxNum: this.yxNum,
            yxSum: this.questionData.frequency,
          };
        } else {
          this.$store.commit("setData", this.dataTypes); //res.data.data 为请求返回的数据
          this.radioLisr = serr.numbers;
          this.textmsg = {
            title: this.gameName,
            content: this.questionData.startCue,
            contentTwo: "",
            image: this.questionData.firstImage, //
            firstWord: this.questionData.firstWord,
            cancel: "取消",
            confirm: "马上开始",
            state: 1,
            yxNum: this.yxNum,
            yxSum: this.questionData.frequency,
          };
        }
        if (this.ShowHidden === true) {
          this.centerDialogVisible = true;
          this.countdown = 5;
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              this.countdown = null;
              clearInterval(this.timer);
              this.clickEvent(false);
            }
          }, 1000);
        } else {
          this.clickEvent(false);
        }
      });
    },

    //开始显示图片出现事件
    clickEvent(envt) {
      this.yxStart = true;
      this.centerDialogVisible = envt;
    },
    //答题弹窗
    answerEvent(evet) {
      this.yxStart = false;
      this.answerPopup = true;
      this.countdown = this.questionData.answerSeconds / 1000 || 10;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.countdown = null;
          clearInterval(this.timer);
          this.choiceQuestion(null);
        }
      }, 1000);
    },
    cdsetse(arr1, arr2) {
      if (arr1 == undefined) {
        return false;
      } else {
        let arr = [];
        // 一一比较元素值，有一个不相等就不等
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i] !== arr2[i]) arr[i] = false;
          else arr[i] = true;
        }
        let flag = arr.findIndex((item) => item === false);
        if (flag === -1) return true;
        else return false;
      }
    },
    // 选择答案事件
    choiceQuestion(event) {
      this.prompt = "";
      clearInterval(this.timer); //点击完先停止定时器
      let actrin = event;
      let correctAnswer = this.questionData.answer;
      let sinsent = "";
      if (this.gameName === "图片快闪") {
        sinsent = this.cdsetse(actrin, correctAnswer);
      } else if (
        this.gameName === "数字舒尔特" ||
        this.gameName === "无独有偶" ||
        this.gameName === "对号入座" ||
        this.gameName === "万里挑一" ||
        this.gameName === "图片连连看" ||
        this.gameName === "声音连连判" ||
        this.gameName === "快速拨号" ||
        this.gameName === "色块排序" ||
        this.gameName === "一清二楚"
      ) {
        sinsent = actrin;
      } else {
        sinsent = JSON.stringify(actrin) === JSON.stringify(correctAnswer);
      }
      let i = this.questionData.frequency === 3 ? 2 : 3;
      if (sinsent === true) {
        this.xuanzhong = 1;
        this.prompt = "恭喜您，答对了";
        this.$refs.answerYes.play(); //play()为播放函数
        this.rightIndex++;
      } else {
        this.xuanzhong = 2;
        this.flag = false;
        this.prompt = "很遗憾，答错了";
        this.$refs.answerNo.play(); //play()为播放函数
        this.errorIndex++;
      }
      // 当前游戏进度等于当前小关卡总数 并且 错误小于2次
      if (this.yxNum === this.questionData.frequency && this.errorIndex < i) {
        this.rightIndex = 0;
        this.errorIndex = 0;
        this.yxNum = 0;
        if (this.typeList && this.courseType !== "体验课程") {
          // 保存游戏进度
          this.addCourseGame();
          // 记录当前关卡结束日志(通关)
          let obj = {
            memberId: this.Information.memberId,
            startTime: this.levelStartTime,
            endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            type: 1,
          };
          this.addEveryLog(obj);
        }
        this.arrayIndex++; //进入下一个游戏
        this.progressIndex++;
        if (this.arrayIndex >= this.chapters.length) {
          this.answerPopup = false;
          this.countdown = null;
          this.prompt = "";
          this.active_index = 2;
          this.loadingBook();
        } else {
          if (this.courseType !== "体验课程") {
            // 记录下一个游戏开始日志
            this.start =
              this.courseName +
              "：" +
              this.chapters[this.progressIndex].gameName;
            this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
            let obj = {
              memberId: this.Information.memberId,
              position: this.start,
              startTime: this.levelStartTime,
              type: 1,
            };
            this.addEveryLog(obj);
          }
          this.timer3 = setTimeout(() => {
            this.yxStart = false;
            this.flag = null;
            this.continue();
            this.ShowHidden = true;
          }, 2000);
        }
      } else if (this.errorIndex === i) {
        this.FailPopup = true;
        this.answerPopup = false;
        this.prompt = "";
        this.countdown = null;
        this.yxStart = false;
        this.yxNum = 0;
        this.rightIndex = 0;
        this.errorIndex = 0;
        this.timer3 = setTimeout(() => {
          this.flag = null;
          this.continue();
          this.ShowHidden = true;
        }, 2000);
        return;
      } else {
        this.timer3 = setTimeout(() => {
          this.yxStart = false;
          this.flag = null;
          this.continue();
        }, 2000);
      }
    },
    // 层层递进
    autoContinue() {
      clearInterval(this.timer); //点击完先停止定时器
      // 当前游戏进度等于当前小关卡总数
      if (this.yxNum === this.questionData.frequency) {
        this.yxNum = 0;
        if (this.typeList && this.courseType !== "体验课程") {
          // 保存游戏进度
          this.addCourseGame();
          // 记录当前关卡结束日志(通关)
          let obj = {
            memberId: this.Information.memberId,
            startTime: this.levelStartTime,
            endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            type: 1,
          };
          this.addEveryLog(obj);
        }
        this.arrayIndex++; //进入下一个游戏
        this.progressIndex++;
        if (this.arrayIndex >= this.chapters.length) {
          this.answerPopup = false;
          this.countdown = null;
          this.prompt = "";
          this.active_index = 2;
          this.loadingBook();
        } else {
          if (this.courseType !== "体验课程") {
            // 记录下一个游戏开始日志
            this.start =
              this.courseName +
              "：" +
              this.chapters[this.progressIndex].gameName;
            this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
            let obj = {
              memberId: this.Information.memberId,
              position: this.start,
              startTime: this.levelStartTime,
              type: 1,
            };
            this.addEveryLog(obj);
          }
          this.timer3 = setTimeout(() => {
            this.yxStart = false;
            this.flag = null;
            this.continue();
            this.ShowHidden = true;
          }, 2000);
        }
      } else {
        this.timer3 = setTimeout(() => {
          this.yxStart = false;
          this.flag = null;
          this.continue();
        }, 2000);
      }
    },
    // 新增会员课程游戏
    addCourseGame() {
      let obj = {
        objId: this.Information.memberId,
        courseId: this.courseId,
        gameId: this.gameId,
      };
      addCourseGame(obj).then((res) => {});
    },

    //继续多处调用方法
    continue() {
      if (!this.isBack) {
        clearInterval(this.timer);
        clearInterval(this.timer3);
        this.determine();
        this.prompt = "";
        this.answerPopup = false;
        this.countdown = null;
        this.FailPopup = false;
        this.xuanzhong = "";
        // this.yxNum++ //游戏进度加一
        if (this.$route.query.courseType == "体验课程") this.queryCourseGame();
        if (this.typeList) this.getTake();
      }
    },
    determine() {
      if (
        this.gameName === "字母快闪" ||
        this.gameName === "字符快闪" ||
        this.gameName === "数字快闪" ||
        this.gameName === "词句快闪" ||
        this.gameName === "图片快闪" ||
        this.gameName === "非此即彼" ||
        this.gameName === "明辨是非" ||
        this.gameName === "记忆犹新" ||
        this.gameName === "层层递进" ||
        this.gameName === "对号入座" ||
        this.gameName === "数字舒尔特" ||
        this.gameName === "无独有偶" ||
        this.gameName === "万里挑一" ||
        this.gameName === "图片连连看" ||
        this.gameName === "声音连连判" ||
        this.gameName === "快速拨号" ||
        this.gameName === "色块排序" ||
        this.gameName === "一清二楚"
      ) {
        this.ShowHidden = false;
      }
    },
    // 游戏观察时间倒计时
    obsver(time) {
      if (
        this.gameName == "无独有偶" ||
        this.gameName == "对号入座" ||
        this.gameName == "图片连连看" ||
        this.gameName == "一清二楚"
      )
        this.countdown = this.questionData.seconds / 1000;
      else this.countdown = this.questionData.seconds;
      if (time) this.countdown = time;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.countdown = null;
          clearInterval(this.timer);
          if (this.gameName !== "一清二楚") this.abcde();
        }
      }, 1000);
    },
    // 游戏时间倒计时
    abcde() {
      if (
        this.gameName === "万里挑一" ||
        this.gameName === "明辨是非" ||
        this.gameName === "非此即彼" ||
        this.gameName === "快速拨号"
      )
        this.countdown = this.questionData.seconds;
      else if (this.gameName === "无独有偶")
        this.countdown = this.questionData.seconds / 1000;
      else this.countdown = this.questionData.answerSeconds / 1000 || 10;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.countdown = null;
          clearInterval(this.timer);
          if (this.gameName !== "一清二楚") this.choiceQuestion();
        }
      }, 1000);
    },
    // 判断加载文章方式
    loadingBook() {
      if (this.courseType === "体验课程") {
        this.readingData = experienceRead.experienceRead.data;
        this.ArticlePopup = true;
        this.articleCountDown();
        this.cRtData = this.readingData[this.readingIndex];
        this.gameName = this.cRtData.course[0].courseArticleName;
        this.directRead();
      } else {
        this.myScriptCourse();
      }
    },
    // h获取文章和题
    myScriptCourse(num) {
      let user = this.Information;
      let index = localStorage.getItem("classIndex");
      let obj = {
        courseId: this.courseId,
        memberId: user.memberId,
        type: index,
      };
      getQuestions(obj).then((res) => {
        let ler = this.$Base64.decode(res.msg);
        let data = JSON.parse(ler);
        this.readingData = data;
        this.ArticlePopup = true;
        if (this.readingIndex !== 0) this.articleCountDown();
        this.cRtData = this.readingData[this.readingIndex];
        if (this.cRtData.msg) {
          this.$message({
            message: this.cRtData.msg,
            type: "warning",
            showClose: true,
          });
        }
        if (this.cRtData.course) {
          this.gameName = this.cRtData.course[0].courseArticleName;
          let bookn = this.readingIndex + 1;
          this.start =
            this.courseName +
            "：阅读 第" +
            bookn +
            "篇《" +
            this.gameName +
            "》";
          if (num == 1 && this.courseType !== "体验课程") this.addEnterLog();
          if (this.courseType !== "体验课程") {
            this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
            let obj = {
              memberId: this.Information.memberId,
              position: this.start,
              startTime: this.levelStartTime,
              type: 1,
            };
            this.addEveryLog(obj);
          }
          this.directRead();
        }
      });
    },
    // 文章弹窗倒计时
    articleCountDown() {
      this.countdown = 5;
      this.timer1 = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          // this.countdown = null;
          // clearInterval(this.timer1)
          this.cdeClick(false);
        }
      }, 1000);
    },

    // 设置单行个数和显示时间
    setCourseMsg() {
      switch (this.courseName) {
        case "第一课":
          this.rowWords = 6;
          this.LinearReadingB = [2, 1, 3];
          this.rowTime = 1765;
          break;
        case "第二课":
          this.rowWords = 6;
          this.LinearReadingB = [2, 1, 3];
          this.rowTime = 870;
          break;
        case "第三课":
          this.rowWords = 8;
          this.LinearReadingB = [3, 1, 4];
          this.rowTime = 780;
          break;
        case "第四课":
          this.rowWords = 8;
          this.LinearReadingB = [3, 1, 4];
          this.rowTime = 580;
          break;
        case "第五课":
          this.rowWords = 10;
          this.LinearReadingB = [4, 2, 4];
          this.rowTime = 575;
          break;
        case "第六课":
          this.rowWords = 10;
          this.LinearReadingB = [4, 2, 4];
          this.rowTime = 480;
          break;
        case "第七课":
          this.rowWords = 12;
          this.LinearReadingB = [5, 2, 5];
          this.rowTime = 490;
          this.isNormal = true;
          break;
        case "第八课":
          this.rowWords = 12;
          this.LinearReadingB = [5, 2, 5];
          this.rowTime = 440;
          this.isNormal = true;
          break;
        case "第九课":
          this.rowWords = 14;
          this.LinearReadingB = [6, 2, 6];
          this.rowTime = 450;
          this.isNormal = true;
          break;
        case "第十课":
          this.rowWords = 14;
          this.LinearReadingB = [6, 2, 6];
          this.rowTime = 450;
          break;
        case "第十一课":
          this.rowWords = 16;
          this.LinearReadingB = [6, 3, 7];
          this.rowTime = 460;
          break;
        case "第十二课":
          this.rowWords = 16;
          this.LinearReadingB = [6, 3, 7];
          this.rowTime = 454;
          break;
        case "第十三课":
          this.rowWords = 18;
          this.LinearReadingB = [7, 3, 8];
          this.rowTime = 440;
          break;
        case "第十四课":
          this.rowWords = 20;
          this.LinearReadingB = [8, 4, 8];
          this.rowTime = 452;
          this.isNormal = true;
          break;
        case "第十五课":
          this.rowWords = 22;
          this.LinearReadingB = [9, 4, 9];
          this.rowTime = 450;
          break;
        case "第十六课":
          this.rowWords = 24;
          this.LinearReadingB = [10, 4, 10];
          this.rowTime = 460;
          break;
        case "第十七课":
          this.rowWords = 26;
          this.LinearReadingB = [10, 5, 11];
          this.rowTime = 455;
          this.isNormal = true;
          break;
        case "第十八课":
          this.rowWords = 28;
          this.LinearReadingB = [11, 5, 12];
          this.rowTime = 465;
          this.isNormal = true;
          break;
      }
    },
    // 前四篇文章处理函数
    directRead() {
      let str = "";
      this.cRtData.course[0].content.forEach((item) => (str = str + item));
      this.fenGeString(str, this.rowWords);
    },
    // 字符串分割(单行字数)
    fenGeString(str, num) {
      let arr = [];
      for (var i = 0; i < str.length; i += num) {
        arr.push(str.substring(i, i + num));
      }
      this.rowNumber = arr.length;
      if (arr[arr.length - 1].length < num) {
        let str = arr[arr.length - 1];
        str = str.padEnd(num, " "); // 字数不够自动补空字符串
        arr[arr.length - 1] = str;
      }
      if (this.readingIndex == 0 || this.readingIndex == 3)
        this.bookArr = this.getSplitArray(arr, 13); //第一篇文章直读法
      if (this.readingIndex == 4 && !this.isNormal)
        this.bookArr = this.getSplitArray(arr, 13); //第一篇文章直读法
      if (this.readingIndex == 1 || this.readingIndex == 2) this.bookArr = arr; //第二篇闪烁跟读
    },
    // 分割结果分组（每页显示几行）
    getSplitArray(list, splitCount) {
      const result = [];
      for (let i = 0; i < list.length; i += splitCount) {
        result.push(list.slice(i, i + splitCount));
      }
      return result;
    },
    addIndex(index, count) {
      this.timer = setTimeout(() => {
        index += 1;
        this.row = index;
        this.$refs.music.play();
        if (this.readingIndex == 0) {
          if (count == 12) {
            count = 0;
            this.Num += 1;
          } else {
            count += 1;
          }
          this.num = count;
        }
        if (index === this.rowNumber) {
          clearTimeout(this.timer); //结束定时器，
          this.timer = null;
          this.ReadItWell();
        } else {
          clearTimeout(this.timer); //结束定时器，
          this.timer = null;
          this.addIndex(index, count);
        }
      }, this.rowTime);
    },
    addIndex1(index, index1, count, numA) {
      this.timer = setTimeout(() => {
        index1 += 1;
        this.$refs.music.play();
        index1 % 2 !== 0 ? (index += 1) : "";
        if (count == 12 && numA == 1) {
          count = 0;
          this.Num += 1;
        } else if (index1 % 2 == 0) {
          count += 1;
        }
        this.num = count;
        if (index === this.rowNumber && numA == 1) {
          clearTimeout(this.timer); //结束定时器，
          this.timer = null;
          this.ReadItWell();
        } else {
          numA == 1 ? (numA = 0) : (numA += 1);
          this.numA = numA;
          clearTimeout(this.timer); //结束定时器，
          this.timer = null;
          this.addIndex1(index, index1, count, numA);
        }
      }, this.rowTime / 2);
    },
    loadTimer() {
      if (this.timer) clearInterval(this.timer);
      if (
        !this.ArticlePopup &&
        this.multipleQuestion &&
        this.bookArr.length > 0
      ) {
        this.$refs.music.play();
        let index = 0; //计算总共显示到第几行
        let index1 = 0; //行数*2显示计次
        let count = 0; //计算每一页显示到第几行
        let numA = 0; //控制文字左右显示
        if (
          this.readingIndex == 0 ||
          this.readingIndex == 1 ||
          this.readingIndex == 2
        ) {
          this.addIndex(index, count);
        } else if (
          this.readingIndex == 3 ||
          (this.readingIndex == 4 && !this.isNormal)
        ) {
          this.addIndex1(index, index1, count, numA);
        }
      }
    },
    // 阅读弹窗事件
    cdeClick(vale) {
      this.countdown = null;
      clearInterval(this.timer1); //清除阅读弹框倒计时
      this.ArticlePopup = vale;
      this.multipleQuestion = true;
      this.xuanzhong = "";
      this.total = 0;
      this.loadTimer();
      this.offClasses = true;
      this.reckonTime = 1;
      if (this.isNormal || this.courseType == "体验课程") {
        this.readTimer = setInterval(() => {
          this.reckonTime++;
        }, 1000);
      }
      // 普通阅读读好了按钮显示时间
      if (this.readingIndex == 4 && this.isNormal) {
        setTimeout(() => {
          this.showBtn = true;
        }, 5000);
      }
    },
    //  读好了事件
    ReadItWell() {
      this.indexs = 0;
      clearInterval(this.timer);
      clearInterval(this.readTimer);
      let list = this.cRtData.course[0].children;
      this.Num = 0;
      this.num = 0;
      this.row = 0;
      this.numA = 0;
      if (list.length == 1) {
        this.$message({
          message: "暂无题目资源",
          type: "warning",
          showClose: true,
        });
        this.pusfunang();
        this.readingIndex++;
        if (this.readingIndex === this.readingData.length) {
          // this.readingIndex = 0
          // this.redIndex = 0
          // this.reanEnd = true
          this.submit();
        } else {
          this.cRtData = this.readingData[this.readingIndex];
          this.gameName = this.cRtData.course[0].courseArticleName;
          // if(this.readingIndex !== 4) this.directRead()
          this.directRead();
          this.multipleQuestion = null;
          this.ArticlePopup = true; //打开阅读弹窗
          this.articleCountDown(), (this.redIndex = 0);
          this.reckonTime = 1;
        }
      } else {
        this.multipleQuestion = false;
        this.radData = list[this.indexs];
        this.radios = "";
        this.austouts();
      }
    },

    format(percentage) {
      return percentage === 100 ? "" : "";
    },
    //   文章答题倒计时
    austouts(seconds) {
      this.isClick = false;
      this.countdown1 = seconds || 10;
      this.timer2 = setInterval(() => {
        this.countdown1--;
        if (this.countdown1 === 0) {
          // this.countdown1 = null;
          this.agreeChange("测试");
        }
      }, 1000);
    },
    agreeChange(val) {
      this.isClick = true;
      let text = val;
      clearInterval(this.timer2); //清楚答题倒计时
      let list = this.cRtData.course[0].children;
      //  this.redIndex++  //下标++
      if (this.radData.answer === text) {
        this.$refs.answerYes.play(); //play()为播放函数
        this.xuanzhong = 1;
        this.total++; //总答对数
        this.percentage += 14.285;
        if (this.redIndex === list.length - 1) {
          if (this.readingIndex === this.readingData.length - 1) {
            this.percentage = 100;
            //  this.readingIndex = 0
            //  this.redIndex = 0
            //  this.reanEnd = true
            this.pusfunang();
            this.submit();
          } else {
            setTimeout(() => {
              this.pusfunang();
              this.readingIndex++;
              this.indexs++;
              this.xuanzhong = "";
              this.cRtData = this.readingData[this.readingIndex];
              this.gameName = this.cRtData.course[0].courseArticleName;
              // 下一篇文章开始日志
              let bookn = this.readingIndex + 1;
              this.start =
                this.courseName +
                "：阅读 第" +
                bookn +
                "篇《" +
                this.gameName +
                "》";
              if (this.courseType !== "体验课程") {
                this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
                let obj = {
                  memberId: this.Information.memberId,
                  position: this.start,
                  startTime: this.levelStartTime,
                  type: 1,
                };
                this.addEveryLog(obj);
              }
              this.directRead();
              this.multipleQuestion = null;
              this.ArticlePopup = true; //阅读弹窗
              this.articleCountDown(), (this.redIndex = 0);
              this.reckonTime = 1;
              this.percentage = 0;
            }, 1000);
          }
        } else {
          setTimeout(() => {
            this.xuanzhong = "";
            this.redIndex++; //下标++
            this.radData = list[this.redIndex];
            this.radios = "";
            this.austouts();
          }, 1000);
        }
      } else {
        this.$refs.answerNo.play(); //play()为播放函数
        this.xuanzhong = 2;
        this.percentage += 14.285;
        if (this.redIndex === list.length - 1) {
          if (this.readingIndex === this.readingData.length - 1) {
            this.percentage = 100;
            this.pusfunang();
            this.submit();
          } else {
            setTimeout(() => {
              this.pusfunang();
              this.readingIndex++;
              this.indexs++;
              this.xuanzhong = "";
              this.cRtData = this.readingData[this.readingIndex];
              this.gameName = this.cRtData.course[0].courseArticleName;
              // 下一篇文章开始日志
              let bookn = this.readingIndex + 1;
              this.start =
                this.courseName +
                "：阅读 第" +
                bookn +
                "篇《" +
                this.gameName +
                "》";
              if (this.courseType !== "体验课程") {
                this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
                let obj = {
                  memberId: this.Information.memberId,
                  position: this.start,
                  startTime: this.levelStartTime,
                  type: 1,
                };
                this.addEveryLog(obj);
              }
              this.directRead();
              this.multipleQuestion = null;
              this.ArticlePopup = true; //阅读弹窗
              this.articleCountDown();
              this.redIndex = 0;
              this.reckonTime = 1;
              this.percentage = 0;
            }, 1000);
          }
        } else {
          setTimeout(() => {
            this.xuanzhong = "";
            this.redIndex++; //下标++
            this.radData = list[this.redIndex];
            this.radios = "";
            this.austouts();
          }, 1000);
        }
      }
    },
    pusfunang() {
      let readSpeed;
      let readScore;
      let readEfficiency;
      // 普通阅读按照计算的速度
      if (
        (this.readingIndex == 4 && this.isNormal) ||
        this.courseType == "体验课程"
      ) {
        readSpeed = Math.ceil(
          (this.cRtData.course[0].number * 60) / this.reckonTime
        );
      } else {
        readSpeed = Number(this.typeList.targetVelocity);
      }
      readScore = Math.ceil((100 / 7) * this.total);
      readEfficiency = Math.ceil((readSpeed * readScore) / 100);
      let obj = {
        memberId: this.Information.memberId,
        courseId: this.courseId,
        courseArticleName: this.cRtData.course[0].courseArticleName,
        readEfficiency: readEfficiency, //  阅读效率  Information
        readSpeed: readSpeed, // 阅读速度
        readScore: readScore, //  阅读成绩
      };
      this.cunData.push(obj);
      // console.log("aaaaaaa===>>>", this.total, this.reckonTime, this.cunData);
      if (this.courseType !== "体验课程") {
        // 记录当前文章结束日志
        let obj1 = {
          memberId: this.Information.memberId,
          startTime: this.levelStartTime,
          endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          type: 1,
        };
        this.addEveryLog(obj1);
      }
      let a = 0,
        b = 0,
        c = 0;
      let arr = this.cunData;
      arr.forEach((v) => {
        a += v.readEfficiency;
        b += v.readScore;
        c += v.readSpeed;
      });
      this.transmit = {
        memberId: this.Information.memberId,
        courseId: this.courseId,
        readEfficiency: Math.ceil(a / 5), //  阅读效率
        readScore: parseFloat((b / 5).toFixed(2)), //  答题分数
        readSpeed: Math.ceil(c / 5), // 阅读速度
        readCourseChapterScoreList: this.cunData,
      };
    },
    // 平均成绩
    submit() {
      let startTime = new Date(this.starttime).getTime();
      let endTime = new Date().getTime();
      let time = Math.ceil((endTime - startTime) / 1000);
      this.transmit.time = time;
      // 判断成绩是否有空值
      let flag;
      if (
        this.transmit.readEfficiency == undefined ||
        Object.is(this.transmit.readEfficiency, NaN) ||
        this.transmit.readSpeed == undefined ||
        this.transmit.readSpeed == Infinity ||
        this.transmit.readScore == undefined
      ) {
        flag = true;
      } else {
        // 判断5篇文章是否有空值
        for (let i = 0; i < this.cunData.length; i++) {
          if (
            this.cunData[i].readEfficiency == undefined ||
            Object.is(this.cunData[i].readEfficiency, NaN) ||
            this.cunData[i].readSpeed == undefined ||
            this.cunData[i].readSpeed == Infinity ||
            this.cunData[i].readScore == undefined
          ) {
            flag = true;
            break;
          }
        }
      }
      // 有空值，不传成绩
      if (flag == true || this.courseType == "体验课程") {
        localStorage.setItem("conset", JSON.stringify(this.transmit));
        setTimeout(() => {
          this.$router.push({
            path: "/achievement",
            query: {
              courseType: this.courseType,
            },
          });
        }, 1000);
      } else {
        // 正常保存课程成绩
        putAverage(this.transmit).then((res) => {
          this.transmit.courseArticleName =
            this.cRtData.course[0].courseArticleName;
          localStorage.setItem("conset", JSON.stringify(this.transmit));
          setTimeout(() => {
            this.$router.push({
              path: "/achievement",
              query: {
                courseType: this.courseType,
              },
            });
          }, 1000);
        });
      }
    },

    //游戏跳关
    yxStep(index) {
      let nextLevel = sessionStorage.getItem("nextLevel");
      if (!this.isBack && !this.FailPopup && nextLevel == 1) {
        this.clearMsg();
        if (this.typeList) this.addCourseGame();
        this.arrayIndex = index; //进入下一个游戏
        this.progressIndex = index;
        if (this.$route.query.courseType == "体验课程") this.queryCourseGame();
        if (this.typeList && this.courseType !== "体验课程") {
          this.gameId = this.chapters[index].gameId;
          this.gameName = this.chapters[index].gameName;
          this.prompt = "";
          // 当前游戏结束日志
          let obj1 = {
            memberId: this.Information.memberId,
            startTime: this.levelStartTime,
            endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            type: 1,
          };
          this.addEveryLog(obj1);
          // 下一个游戏开始日志
          this.start =
            this.courseName + "：" + this.chapters[this.progressIndex].gameName;
          this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
          let obj = {
            memberId: this.Information.memberId,
            position: this.start,
            startTime: this.levelStartTime,
            type: 1,
          };
          this.addEveryLog(obj);
          if (
            this.gameGradeIdArr[index] &&
            this.gameGradeIdArr[index].gameGradeId
          ) {
            let arry = this.gameGradeIdArr[index].gameGradeId;
            this.heangbuo(arry); //查询游戏数据
          } else {
            this.alginFlag = true;
            this.progressIndex = this.chapters.length - 1;
            this.arrayIndex = this.chapters.length - 1;
            this.active_index = 2;
            this.prompt = "";
            this.myScriptCourse(1);
          }
        }
      }
    },
    //    123选择跳关
    handleStep(currentStep) {
      if (this.courseType !== "体验课程") {
        // 当前关卡结束日志
        let obj = {
          memberId: this.Information.memberId,
          startTime: this.levelStartTime,
          endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          type: 1,
        };
        this.addEveryLog(obj);
      }

      let nextLevel = sessionStorage.getItem("nextLevel");
      if (!this.isBack && !this.FailPopup && nextLevel == 1) {
        this.clearMsg();
        this.active_index = currentStep;
        if (currentStep === 0) {
          this.timeOut = true;
        }
        if (currentStep === 1) {
          if (this.$route.query.courseType == "体验课程")
            this.queryCourseGame();
          if (this.typeList) this.getTake(2);
        }
        if (currentStep === 2) {
          this.loadingBook();
        }
      }
    },
    clearMsg() {
      this.multipleQuestion = null;
      this.prompt = "";
      this.arrayIndex = 0;
      this.progressIndex = 0;
      this.rightIndex = 0;
      this.errorIndex = 0;
      this.xuanzhong = "";
      this.yxNum = 0;
      this.countdown = null;
      this.yxStart = false;
      this.showBtn = false;
      this.questionData = {};
      this.flag = null;
      this.bookArr = [];
      this.cRtData = {};
      this.radData = {};
      clearInterval(this.timer); //结束定时器，
      clearInterval(this.timer1); //结束定时器，
      clearInterval(this.timer2); //结束定时器，
      clearInterval(this.timer3); //结束定时器，
      clearInterval(this.readTimer);
      this.Num = 0;
      this.num = 0;
      this.row = 0;
      this.numA = 0;
      this.centerDialogVisible = false;
      this.answerPopup = false;
      this.FailPopup = false;
      this.ArticlePopup = false;
    },
    //  游戏中途退出
    yxOutHandle() {
      if (!this.FailPopup) {
        // 阅读文章时点击返回直接退出
        if (this.active_index == 2) {
          this.exitReturn();
        } else this.isBack = true;
        clearInterval(this.timer); //结束定时器，
        clearInterval(this.timer1); //结束定时器，
        clearInterval(this.timer2); //结束定时器，
        clearInterval(this.timer3); //结束定时器，
        clearInterval(this.readTimer);
        this.yxStart = false;
        this.flag = null;
        this.centerDialogVisible = false;
        this.FailPopup = false;
        this.answerPopup = false;
        this.countdown = null;
        this.ArticlePopup = false;
        this.questionData = {};
      }
    },
    //返回上一页
    exitReturn() {
      // 记录当前关卡结束日志(通关)
      let obj = {
        memberId: this.Information.memberId,
        startTime: this.levelStartTime,
        endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        type: 1,
      };
      this.addEveryLog(obj);
      this.$router.push({ path: "course" });
    },
    cancleBack() {
      this.isBack = false;
      if (this.active_index === 1) {
        this.yxNum--;
        if (this.$route.query.courseType == "体验课程") this.queryCourseGame();
        if (this.typeList) this.getTake();
      }
      if (this.active_index === 2) {
        this.gameName = this.cRtData.course[0].courseArticleName;
        // 读文章
        if (this.multipleQuestion) {
          this.Num = 0;
          this.num = 0;
          this.row = 0;
          this.numA = 0;
          this.loadTimer(); //重新打开定时器
        } else {
          //答题
          this.austouts(this.countdown1);
        }
      }
    },
    addlog() {
      let end = "";
      let num = this.readingIndex + 1;
      if (this.active_index == 2)
        end =
          this.courseName + "：阅读 第" + num + "篇《" + this.gameName + "》";
      else if (this.active_index == 1)
        end = this.courseName + "：" + this.gameName;
      else end = this.courseName + "：" + "音乐";
      this.readingIndex = 0;
      let obj = {
        memberId: this.Information.memberId,
        dataTime: dayjs().format("YYYY-MM-DD"),
        startTime: this.starttime,
        endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        type: 1,
        start: this.start,
        end,
      };
      logsbmit(obj).then((res) => {});
    },
  },

  beforeDestroy() {
    clearInterval(this.timer); //结束定时器，
    clearInterval(this.timer1); //结束定时器，
    clearInterval(this.timer2); //结束定时器，
    clearInterval(this.timer3); //结束定时器，
    clearInterval(this.readTimer);
    // if (this.courseType !== "体验课程") this.addlog();
  },
};
</script>

<style lang="scss" scoped>
.el-icon-arrow-left {
  cursor: pointer;
}
#apppp {
  height: 100%; /*设置高度为屏幕高度*/
  display: flex; /* 使用弹性盒子布局 */
  flex-direction: column; /* 主轴方向为垂直方向 */
}
.div1 {
  background-color: #f1f1f1;
  padding: 10px;
  height: 40px; /* 设置固定高度 */
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.div2 {
  background-color: #d4eadf;
  //flex-grow: 1; /* 让该元素自适应剩余高度 */
  height: calc(100% - 130px);
}
.div3 {
  padding: 10px;
  height: 50px; /* 设置固定高度 */
  line-height: 50px;
  z-index: 20008;
}
.articleTitle {
  font-size: 18px;
}
.yuandian {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-color: #2097e7;
  border-radius: 50%;
  margin-left: 6px;
  margin-top: 5px;
}
.yuanActiv {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-color: #45a91b;
  border-radius: 50%;
  margin-left: 6px;
  margin-top: 5px;
}
.image-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  height: 100%; /* 容器高度 */
  overflow: hidden; /* 隐藏溢出内容 */
}
.image-item {
  width: 100px; /* 图片宽度 */
  height: 100px; /* 图片高度 */
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-100%, -100%); /* 初始位置在左上角 */
  transition: all 0.5s ease-in-out; /* 过渡效果 */
}
.image-item.show {
  transform: translate(0, 0); /* 显示图片 */
}

.dot {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  .tton {
    color: #000000;
    width: 100px;
    height: 35px;
    border: none;
    border-radius: 30px;
    margin-left: 10px;
  }
  .ttonse {
    color: #ffffff;
    background: linear-gradient(to right, #2d85ff, #2da5ff, #2dbeff);
  }
}

::v-deep .el-step.is-horizontal .el-step__line {
  top: 24px;
}

.bag {
  width: 100%;
  height: 100vh;
}
.passaGes {
  width: 62%;
  height: 100%;
  margin: 0 auto;
  padding: 30px 20px;
  font-size: 3vh;
  box-sizing: border-box;
  line-height: 2;
  text-align: justify;
  letter-spacing: 1.5px;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  background: #ffffff;
  position: relative;
  .indent {
    text-indent: 2em;
  }
  .flex-box {
    height: 100%;
  }
  .lineB-color {
    color: #999999;
  }
  .row {
    height: 7.5%;
    font-size: 3vh;
    text-align: center;
    opacity: 0;
  }

  .hide {
    opacity: 0;
  }
  .active {
    opacity: 1;
  }
  .fs-bold {
    color: #000000;
  }
  .flicker {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .flicker-box {
      text-align: center;
    }
  }
  .position-0 {
    position: absolute;
    top: 20%;
    left: 2%;
  }

  .position-1 {
    position: absolute;
    top: 20%;
    right: 2%;
  }

  .position-2 {
    position: absolute;
    bottom: 20%;
    left: 2%;
  }

  .position-3 {
    position: absolute;
    bottom: 20%;
    right: 2%;
  }
}
.passaGes::-webkit-scrollbar {
  display: none;
}
.scroll {
  //
}
.rowTitle {
  font-size: 3vh;
}
.questions {
  width: 40vw;
  font-size: 3vh;
  line-height: 1.5;
  background: #ffffff;
  margin: 10% auto 0;
  text-indent: 0;
  padding: 2vh;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  .centerImg {
    width: 150px;
    height: 150px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
}
.disabled {
  pointer-events: none;
}
/*  选中后radio文本的颜色 */
::v-deep .el-radio__label {
  color: #000000;
  font-size: 2.6vh;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #000000;
  font-size: 2.6vh;
}
/* radio选中后小圆点的颜色 */
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: #4a62e7 !important;
  border-color: #ffffff !important;
}
/* // hover时颜色 */
::v-deep .el-radio__inner:hover {
  border-color: #4a62e7;
}
.aud {
  display: none;
}
</style>

